const debounce = require('lodash/debounce');

function replaceUrlParam(url, pmin, pmax) {
    let paramURL = url;
    if (paramURL.indexOf('https') === -1) {
        paramURL = `${window.location.origin}${url}`;
    }

    const newURL = new URL(paramURL);
    newURL.searchParams.set('pmin', pmin);
    newURL.searchParams.set('pmax', pmax);

    return newURL;
}

function updatePriceButton(pmin, pmax) {
    const priceSliderButton = $('.price-slider-refinement-button');
    priceSliderButton.find('.pmin').text(pmin);
    priceSliderButton.find('.pmax').text(pmax);

    const permalinkURL = $('.permalink').val();
    const priceSliderButtonHREF = $('.active-filters ul li').length
        ? permalinkURL : priceSliderButton.attr('data-href');
    const updatedURL = replaceUrlParam(priceSliderButtonHREF,
        parseInt(pmin, 10), parseInt(pmax, 10));

    const minValue = parseInt(document.querySelector('#min').min, 10);
    const maxValue = parseInt(document.querySelector('#max').max, 10);
    const differenceValue = maxValue - minValue;
    const multiRangeProgressbar = $('.multi-range-bar.after');
    const percentMin = (parseInt(pmin, 10) - minValue) / differenceValue;
    const percentMax = (parseInt(pmax, 10) - minValue) / differenceValue;
    const leftbarPosition = percentMin * 100;
    const rightbarPosition = 100 - (percentMax * 100);
    multiRangeProgressbar.css('left', `${leftbarPosition >= 0 ? leftbarPosition : 0}%`);
    multiRangeProgressbar.css('right', `${rightbarPosition}%`);

    priceSliderButton.attr('data-href', updatedURL.href);
    priceSliderButton.parents('li').addClass('checked');
    priceSliderButton.find('.checkbox-wrapper').addClass('selected');

    priceSliderButton.trigger('click');

    document.querySelector('#from').textContent = `${pmin}`;
    document.querySelector('#to').textContent = `${pmax}`;
}

const priceSlider = () => {
    const debounceTime = 500;
    const docReady = $(document.body);

    if ($('.multi-range').length) {
        window.localStorage.setItem('minPrice', document.querySelector('#min').value);
        window.localStorage.setItem('maxPrice', document.querySelector('#max').value);

        docReady.on('input', '#max', debounce(() => {
            const minSlider = document.querySelector('#min');
            const maxSlider = document.querySelector('#max');
            const minValue = parseInt(minSlider.value, 10);
            const maxValue = parseInt(maxSlider.value, 10);

            if (maxValue < minValue + 10) {
                minSlider.value = maxValue - 10;

                if (minValue === parseInt(minSlider.min, 10)) {
                    maxSlider.value = 10;
                }
            }

            updatePriceButton(minValue, maxValue);
        }, debounceTime));

        docReady.on('input', '#min', debounce(() => {
            const minSlider = document.querySelector('#min');
            const maxSlider = document.querySelector('#max');
            const minValue = parseInt(minSlider.value, 10);
            const maxValue = parseInt(maxSlider.value, 10);

            if (minValue > maxValue - 10) {
                maxSlider.value = minValue + 10;

                if (maxValue === parseInt(maxSlider.max, 10)) {
                    minSlider.value = parseInt(maxSlider.max, 10) - 10;
                }
            }

            updatePriceButton(minValue, maxValue);
        }, debounceTime));
    }
};

module.exports = {
    priceSlider,
};
